import React from 'react';
import PropTypes from 'prop-types';
import SendingFacilityListContainer from './List/SendingFacilityList.react';
import SendingFacilityFormContainer from './Form/SendingFacilityForm.react';
import { Route, Switch, Redirect } from 'gwx-voyager-components';

/**
 * Containing component that presents the various SendingFacility components
 * and their respective subroutes.
 */
const SendingFacility = ({ match }) => (
	<div>
		<Switch>
			<Route exact path={match.path} />
			<Route exact path={`${match.path}/edit/:sfid`} component={SendingFacilityFormContainer} />
			<Redirect to='/pageNotFound' />
		</Switch>
		<SendingFacilityListContainer />
	</div>
);
SendingFacility.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

export default SendingFacility;
